import React from "react";
import { Recycle, TreePine, Hammer, Shield } from "lucide-react";
import "../styles/About.css";

const About = () => {
  const features = [
    {
      icon: <Recycle size={28} />,
      title: "Sustentabilidade",
      description:
        "Reaproveitamos dormentes ferroviários, dando nova vida à madeira nobre e contribuindo para um futuro mais sustentável.",
    },
    {
      icon: <TreePine size={28} />,
      title: "Madeira Nobre",
      description:
        "Trabalhamos exclusivamente com madeiras de alta qualidade, selecionadas pelos anos de exposição e resistência.",
    },
    {
      icon: <Hammer size={28} />,
      title: "Artesanato Premium",
      description:
        "Cada peça é cuidadosamente trabalhada por artesãos experientes, garantindo acabamento impecável e durabilidade.",
    },
    {
      icon: <Shield size={28} />,
      title: "Qualidade Garantida",
      description:
        "Oferecemos garantia em todos os nossos produtos, assegurando a satisfação e tranquilidade dos nossos clientes.",
    },
  ];

  return (
    <section id="empresa" className="about">
      <div className="about-container">
        {/* Cabeçalho */}
        <div className="about-header">
          <h2>Sobre a ROS Dormentes</h2>
          <p>
            A procura por móveis fabricados usando madeira de demolição como
            matéria-prima aumentou muito nos últimos anos. O aspecto rústico
            desse tipo de material ganha muitos adeptos que buscam produtos
            diferenciados e únicos.
          </p>
        </div>

        {/* Texto + Paleta */}
        <div className="about-content">
          <div className="about-text">
            <h3>Tradição e Inovação em Cada Peça</h3>
            <p>
              Há mais de uma década, a ROS Dormentes se dedica a transformar
              madeira de demolição em móveis únicos e sofisticados. Nossa
              especialidade está em criar peças que combinam a história e
              resistência da madeira ferroviária com design contemporâneo e
              acabamento premium.
            </p>
            <p>
              Atendemos clientes exigentes que buscam exclusividade e qualidade
              superior. Cada projeto é desenvolvido sob medida, respeitando as
              características naturais da madeira e as necessidades específicas
              de cada ambiente.
            </p>

            <div className="metrics">
              <div>
                <h4>15+</h4>
                <span>Anos</span>
              </div>
              <div>
                <h4>500+</h4>
                <span>Projetos</span>
              </div>
              <div>
                <h4>100%</h4>
                <span>Qualidade</span>
              </div>
            </div>
          </div>

          {/* Paleta visual */}
          <div className="about-palette">
            <div className="color-box color-1"></div>
            <div className="color-box color-2"></div>
            <div className="color-box color-3"></div>
            <div className="color-box color-4"></div>
          </div>
        </div>

        {/* Features */}
        <div className="features">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="icon">{f.icon}</div>
              <h4>{f.title}</h4>
              <p>{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
